import { hoverDynamic } from './hover';
import { initImageCarousel } from './swiperCarousel';

export function drawer() {

  function drawerInit() {
    document.body.classList.remove('is-drawer-active');
    if(drawer) drawer.innerHTML = '';
  }

  // ドロワーハンドラ
  function drawerHandler() {
    document.body.classList.remove('is-nav-active', 'is-drawer-filter-active');
    document.body.classList.add('is-drawer-active');
    const hov = drawer.querySelectorAll('a, button, .js-hov');
    if(hov.length) {
      hov.forEach((el) => {
        hoverDynamic(el);
      })
    }
  }

  const drawer = document.querySelector('.js-drawer');

  // ドロワーが非表示になるたびに中身をクリア
  if(drawer) {
    drawer.addEventListener('transitionend', function() {
      if(!document.body.classList.contains('is-drawer-active')) {
        drawer.innerHTML = '';
      }
    });
  }

  // 出展者ドロワー
  const exhibitorsPushTrigger = document.querySelectorAll('[data-exhibitors-id]');
  if(exhibitorsPushTrigger.length){
    exhibitorsPushTrigger.forEach((el) => {
      const exhibitorsid = el.dataset.exhibitorsId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        if(drawer) drawer.innerHTML = '';

        if(exhibitorsid && exhibitorsData) {
          const foundElement = exhibitorsData.find((element) => element['id'] == exhibitorsid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const b = foundElement['booth']
            const bn = foundElement['boothnumber']
            const a = foundElement['area']
            const imgs = foundElement['images']
            const d = foundElement['description']
            const uw = foundElement['url_web']
            const ui = foundElement['url_instagram']
            const ux = foundElement['url_x']
            const uf = foundElement['url_facebook']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('textsize-medium', 'font-bold', 'lh1_5', 'overflowwrap-breakword');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            if(imgs && imgs.length) {
              if(imgs.length > 1) {
                const wrapEl = document.createElement('div');
                wrapEl.classList.add('exhibitor-carousel', 'swiper-wrap', 'rowm-2');
                const carouselEl = document.createElement('div');
                carouselEl.classList.add('swiper-container', 'aspect-4-3');
                const wrapper = document.createElement('div');
                wrapper.classList.add('swiper-wrapper');
                imgs.forEach((src) => {
                  const slide = document.createElement('div');
                  slide.classList.add('swiper-slide');
                  const img = document.createElement('img');
                  img.src = src;
                  img.alt = '';
                  slide.appendChild(img);
                  wrapper.appendChild(slide);
                });
                carouselEl.appendChild(wrapper);
                wrapEl.appendChild(carouselEl);
                const controls = document.createElement('div');
                controls.classList.add('position-relative', 'rowm-0_5', 'flex', 'is-justify-content-center');
                const prevBtn = document.createElement('div');
                prevBtn.classList.add('swiper-button-prev');
                prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 19L8 12L15 5" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                controls.appendChild(prevBtn);
                const nextBtn = document.createElement('div');
                nextBtn.classList.add('swiper-button-next');
                nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5L16 12L9 19" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                controls.appendChild(nextBtn);
                const count = document.createElement('div');
                count.classList.add('swiper-count');
                controls.appendChild(count);
                wrapEl.appendChild(controls);
                drawer.appendChild(wrapEl);
                initImageCarousel(carouselEl);
              } else {
                const singleImg = document.createElement('div');
                singleImg.classList.add('exhibitor-carousel', 'rowm-2', 'aspect-4-3');
                const img = document.createElement('img');
                img.src = imgs[0];
                img.alt = '';
                singleImg.appendChild(img);
                drawer.appendChild(singleImg);
              }
            }

            let attr = '';
            if(b.length || bn || a.length){
              attr = document.createElement('div');
              attr.classList.add('rowm-2', 'lh1_5');
              drawer.appendChild(attr);
            }

            if(b.length){
              const container = document.createElement('div');
              container.classList.add('rowm-1', 'flex');
              const label = document.createElement('p');
              label.classList.add('font-bold', 'pr-0_5');
              label.innerHTML = fabfLabels.venue;
              container.appendChild(label);
              const booth = document.createElement('div');
              booth.classList.add('flex', 'flex-slash');
              b.forEach((bb) => {
                const el = document.createElement('p');
                const title = bb['title'];
                if(title) {
                  el.innerHTML = `${title}`;
                }
                booth.appendChild(el);
              })
              container.appendChild(booth);
              if(attr) {
                attr.appendChild(container);
              }
            }

            if(bn){
              const el = document.createElement('p');
              el.classList.add('rowm-1');
              el.innerHTML = `<b>${fabfLabels.boothNo}</b> ${bn}`;
              attr.appendChild(el);
            }

            if(a.length){
              const container = document.createElement('div');
              container.classList.add('rowm-1', 'flex');
              const label = document.createElement('p');
              label.classList.add('font-bold', 'pr-0_5');
              label.innerHTML = fabfLabels.base;
              container.appendChild(label);
              const area = document.createElement('div');
              area.classList.add('flex', 'flex-slash');
              a.forEach((aa) => {
                const parent = document.createElement('div');
                parent.classList.add('flex', 'flex-hyphen');
                const title = document.createElement('p');
                title.innerHTML = `${aa['title']}`;
                const childs_arr = aa['childs'];
                if(childs_arr.length) {
                  const childs = document.createElement('div');
                  childs.classList.add('flex', 'flex-comma');
                  childs_arr.forEach((c) => {
                    const el = document.createElement('p');
                    el.innerHTML = `${c['title']}`;
                    childs.appendChild(el);
                  });
                  parent.appendChild(title);
                  parent.appendChild(childs);
                } else {
                  parent.appendChild(title);
                }
                area.appendChild(parent);
              })
              container.appendChild(area);
              if(attr) {
                attr.appendChild(container);
              }
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }

            const uwFiltered = uw.filter((u) => u['url']);
            if(uwFiltered.length){
              const ul = document.createElement('ul');

              ul.classList.add('lh1_5', 'rowm-2');

              uwFiltered.forEach((u) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5', 'overflowwrap-breakword');
                const _el = document.createElement('a');
                const label = u['label'];
                const url = u['url'];
                _el.setAttribute('href', url);
                _el.setAttribute('target', '_blank');
                _el.setAttribute('rel', 'noopener');
                _el.classList.add('textdecoration-underline', 'hover-textdecoration-none', 'hover-textdecoration-target');
                if(label) {
                  _el.innerHTML = `${label}`;
                } else {
                  _el.innerHTML = `${url}`;
                }
                el.appendChild(_el);
                ul.appendChild(el);
              })
              drawer.appendChild(ul);
            }

            const snsItems = [];
            ui.forEach((u) => { if(u['url']) snsItems.push({ type: 'instagram', url: u['url'] }); });
            ux.forEach((u) => { if(u['url']) snsItems.push({ type: 'x', url: u['url'] }); });
            uf.forEach((u) => { if(u['url']) snsItems.push({ type: 'facebook', url: u['url'] }); });

            if(snsItems.length) {
              const snsRow = document.createElement('div');
              snsRow.classList.add('sns-icons', 'rowm-2');

              const svgMap = {
                instagram: '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="M469.346 369.027c0 55.713-45.44 100.644-100.446 100.644h-226.004c-55.604 0-100.446-45.529-100.446-100.644v-226.448c0-55.713 45.44-100.644 100.446-100.644h226.004c55.604 0 100.446 45.529 100.446 100.644v226.448zm-100.446-369.027h-226.004c-78.922 0-142.896 64.1-142.896 142.579v226.448c0 78.478 63.975 142.579 142.299 142.579h226.601c78.324 0 142.299-64.1 142.299-142.579v-226.448c0-78.478-63.975-142.579-142.299-142.579z"></path><path d="M255.898 346.262c-49.625 0-90.282-40.737-90.282-90.46 0-49.723 40.657-90.46 90.282-90.46s90.282 40.737 90.282 90.46c0 49.723-40.657 90.46-90.282 90.46m0-222.854c-72.943 0-132.134 59.907-132.134 132.394 0 73.087 59.191 132.394 132.134 132.394 72.943 0 132.134-59.308 132.134-132.394 0-72.487-59.191-132.394-132.134-132.394"></path><path d="M391.62 86.865c18.822 0 34.08 15.288 34.08 34.147 0 18.859-15.258 34.147-34.08 34.147s-34.08-15.288-34.08-34.147c0-18.859 15.258-34.147 34.08-34.147"></path></g></svg>',
                x: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M300.054 219.765L472.441 19.379h-40.85L281.907 193.37 162.356 19.379H24.466l180.786 263.107L24.467 492.62h40.852L223.39 308.88 349.644 492.62h137.89l-187.49-272.856h.01zm-55.953 65.039l-18.317-26.2L80.039 50.132h62.747l117.618 168.244 18.317 26.2 152.89 218.69h-62.748L244.101 284.815v-.01z"></path></svg>',
                facebook: '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M298.232 511.998v-256.03h75.734l10.036-88.23h-85.77l.13-44.158c0-23.012 2.343-35.341 37.758-35.341h47.346V0H307.72C216.74 0 184.714 42.8 184.714 114.777v52.973H128v88.23h56.714V512H298.23l.002-.002z" fill-rule="evenodd"></path></svg>'
              };

              snsItems.forEach((item) => {
                const a = document.createElement('a');
                a.classList.add('sns-icon', 'social-' + item.type, 'js-hov');
                a.setAttribute('href', item.url);
                a.setAttribute('target', '_blank');
                a.setAttribute('rel', 'noopener');
                a.innerHTML = svgMap[item.type];
                snsRow.appendChild(a);
              });
              drawer.appendChild(snsRow);
            }
            drawerHandler();
          }
        }
      })
    })
  }

  // フレンズドロワー
  function openFriendsDrawer(friendsid) {
    if(drawer) drawer.innerHTML = '';
    if(!friendsid || typeof friendsData === 'undefined' || !friendsData) return;
    const foundElement = friendsData.find((element) => element['id'] == friendsid);
    if(!foundElement || !drawer) return;

    const t = foundElement['title'];
    const l = foundElement['location'];
    const ad = foundElement['address'];
    const bh = foundElement['business_hours'];
    const cd = foundElement['closed_day'];
    const imgs = foundElement['images'];
    const d = foundElement['description'];
    const w = foundElement['website'];
    const ig = foundElement['instagram'];
    const gn = foundElement['genre'] || [];

    if(t){
      const drawerTitle = document.createElement('h4');
      drawerTitle.classList.add('textsize-medium', 'font-bold', 'lh1_5', 'overflowwrap-breakword');
      drawerTitle.innerHTML = t;
      drawer.appendChild(drawerTitle);
    }

    if(imgs && imgs.length) {
      if(imgs.length > 1) {
        const wrapEl = document.createElement('div');
        wrapEl.classList.add('exhibitor-carousel', 'swiper-wrap', 'rowm-2');
        const carouselEl = document.createElement('div');
        carouselEl.classList.add('swiper-container', 'aspect-4-3');
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');
        imgs.forEach((src) => {
          const slide = document.createElement('div');
          slide.classList.add('swiper-slide');
          const img = document.createElement('img');
          img.src = src;
          img.alt = '';
          slide.appendChild(img);
          wrapper.appendChild(slide);
        });
        carouselEl.appendChild(wrapper);
        wrapEl.appendChild(carouselEl);
        const controls = document.createElement('div');
        controls.classList.add('position-relative', 'rowm-0_5', 'flex', 'is-justify-content-center');
        const prevBtn = document.createElement('div');
        prevBtn.classList.add('swiper-button-prev');
        prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 19L8 12L15 5" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        controls.appendChild(prevBtn);
        const nextBtn = document.createElement('div');
        nextBtn.classList.add('swiper-button-next');
        nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5L16 12L9 19" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        controls.appendChild(nextBtn);
        const count = document.createElement('div');
        count.classList.add('swiper-count');
        controls.appendChild(count);
        wrapEl.appendChild(controls);
        drawer.appendChild(wrapEl);
        initImageCarousel(carouselEl);
      } else {
        const singleImg = document.createElement('div');
        singleImg.classList.add('exhibitor-carousel', 'rowm-2', 'aspect-4-3');
        const img = document.createElement('img');
        img.src = imgs[0];
        img.alt = '';
        singleImg.appendChild(img);
        drawer.appendChild(singleImg);
      }
    }

    const appendAttr = (parent, labelText, valueHtml) => {
      const container = document.createElement('div');
      container.classList.add('rowm-1', 'flex');
      const label = document.createElement('p');
      label.classList.add('font-bold', 'pr-0_5');
      label.innerHTML = labelText;
      container.appendChild(label);
      const value = document.createElement('p');
      value.innerHTML = valueHtml;
      container.appendChild(value);
      parent.appendChild(container);
    };

    if(l || ad || bh || cd || (gn && gn.length)) {
      const attr = document.createElement('div');
      attr.classList.add('rowm-2', 'lh1_5');
      if(gn && gn.length) {
        const container = document.createElement('div');
        container.classList.add('rowm-1', 'flex');
        const label = document.createElement('p');
        label.classList.add('font-bold', 'pr-0_5');
        label.innerHTML = fabfLabels.genre;
        container.appendChild(label);
        const value = document.createElement('div');
        value.classList.add('flex', 'flex-slash');
        gn.forEach((g) => {
          const p = document.createElement('p');
          p.classList.add('genre-text');
          if(g.color) p.style.setProperty('--genre-color', g.color);
          p.innerHTML = g['title'] || '';
          value.appendChild(p);
        });
        container.appendChild(value);
        attr.appendChild(container);
      }
      if(l) appendAttr(attr, fabfLabels.location, l);
      if(ad) appendAttr(attr, fabfLabels.address, ad.replace(/\n/g, '<br>'));
      if(bh) appendAttr(attr, fabfLabels.businessHours, bh);
      if(cd) appendAttr(attr, fabfLabels.closedDay, cd);
      drawer.appendChild(attr);
    }

    if(ad) {
      const query = [t || '', ad].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
      const mapsUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(query);
      const mapsP = document.createElement('p');
      mapsP.classList.add('rowm-2', 'flex');
      const mapsA = document.createElement('a');
      mapsA.setAttribute('href', mapsUrl);
      mapsA.setAttribute('target', '_blank');
      mapsA.setAttribute('rel', 'noopener');
      mapsA.classList.add('genre-pill', 'flex', 'is-align-items-center', 'border', 'hrem-2', 'pl-0_75', 'pr-0_75', 'radius-small');
      mapsA.innerHTML = fabfLabels.viewOnGoogleMaps || 'View on GoogleMaps';
      mapsP.appendChild(mapsA);
      drawer.appendChild(mapsP);
    }

    if(d){
      const drawerDescription = document.createElement('div');
      drawerDescription.classList.add('pt-2', 'text', 'lh2');
      drawerDescription.innerHTML = d;
      drawer.appendChild(drawerDescription);
    }

    if(w){
      const ul = document.createElement('ul');
      ul.classList.add('lh1_5', 'rowm-2');
      const li = document.createElement('li');
      li.classList.add('rowm-0_5', 'overflowwrap-breakword');
      const a = document.createElement('a');
      a.setAttribute('href', w);
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
      a.classList.add('textdecoration-underline', 'hover-textdecoration-none', 'hover-textdecoration-target');
      a.innerHTML = w;
      li.appendChild(a);
      ul.appendChild(li);
      drawer.appendChild(ul);
    }

    if(ig){
      const snsRow = document.createElement('div');
      snsRow.classList.add('sns-icons', 'rowm-2');
      const a = document.createElement('a');
      a.classList.add('sns-icon', 'social-instagram', 'js-hov');
      a.setAttribute('href', ig);
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
      a.innerHTML = '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="M469.346 369.027c0 55.713-45.44 100.644-100.446 100.644h-226.004c-55.604 0-100.446-45.529-100.446-100.644v-226.448c0-55.713 45.44-100.644 100.446-100.644h226.004c55.604 0 100.446 45.529 100.446 100.644v226.448zm-100.446-369.027h-226.004c-78.922 0-142.896 64.1-142.896 142.579v226.448c0 78.478 63.975 142.579 142.299 142.579h226.601c78.324 0 142.299-64.1 142.299-142.579v-226.448c0-78.478-63.975-142.579-142.299-142.579z"></path><path d="M255.898 346.262c-49.625 0-90.282-40.737-90.282-90.46 0-49.723 40.657-90.46 90.282-90.46s90.282 40.737 90.282 90.46c0 49.723-40.657 90.46-90.282 90.46m0-222.854c-72.943 0-132.134 59.907-132.134 132.394 0 73.087 59.191 132.394 132.134 132.394 72.943 0 132.134-59.308 132.134-132.394 0-72.487-59.191-132.394-132.134-132.394"></path><path d="M391.62 86.865c18.822 0 34.08 15.288 34.08 34.147 0 18.859-15.258 34.147-34.08 34.147s-34.08-15.288-34.08-34.147c0-18.859 15.258-34.147 34.08-34.147"></path></g></svg>';
      snsRow.appendChild(a);
      drawer.appendChild(snsRow);
    }

    drawerHandler();
  }

  // 外部からドロワーを開けるよう公開
  window.openFriendsDrawer = openFriendsDrawer;

  const friendsPushTrigger = document.querySelectorAll('[data-friends-id]');
  if(friendsPushTrigger.length){
    friendsPushTrigger.forEach((el) => {
      const friendsid = el.dataset.friendsId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        openFriendsDrawer(friendsid);
      })
    })
  }

  // フレンズ連動企画ドロワー
  const friendsProjectsPushTrigger = document.querySelectorAll('[data-friends-projects-id]');
  if(friendsProjectsPushTrigger.length){
    friendsProjectsPushTrigger.forEach((el) => {
      const friendsProjectsid = el.dataset.friendsProjectsId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        if(drawer) drawer.innerHTML = '';

        if(friendsProjectsid && friendsProjectsData) {
          const foundElement = friendsProjectsData.find((element) => element['id'] == friendsProjectsid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const l = foundElement['location']
            const i = foundElement['image']
            const d = foundElement['description']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('textsize-medium', 'font-bold', 'lh1_5', 'overflowwrap-breakword');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            if(i){
              const drawerImage = document.createElement('img');
              drawerImage.classList.add('rowm-2');
              drawerImage.src = i;
              drawer.appendChild(drawerImage);
            }

            if(l){
              const attr = document.createElement('div');
              attr.classList.add('rowm-2', 'lh1_5');
              const container = document.createElement('div');
              container.classList.add('rowm-1', 'flex');
              const label = document.createElement('p');
              label.classList.add('font-bold', 'pr-0_5');
              label.innerHTML = fabfLabels.location;
              container.appendChild(label);
              const value = document.createElement('p');
              value.innerHTML = l;
              container.appendChild(value);
              attr.appendChild(container);
              drawer.appendChild(attr);
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }
            drawerHandler();
          }
        }
      })
    })
  }

  // Yummyドロワー
  const yummyPushTrigger = document.querySelectorAll('[data-yummy-id]');
  if(yummyPushTrigger.length){
    yummyPushTrigger.forEach((el) => {
      const yummyid = el.dataset.yummyId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        if(drawer) drawer.innerHTML = '';

        if(yummyid && yummyData) {
          const foundElement = yummyData.find((element) => element['id'] == yummyid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const g = foundElement['genre']
            const o = foundElement['openingday']
            const imgs = foundElement['images']
            const d = foundElement['description']
            const info = foundElement['information']
            const uw = foundElement['url_web']
            const ui = foundElement['url_instagram']
            const ux = foundElement['url_x']
            const uf = foundElement['url_facebook']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('textsize-medium', 'font-bold', 'lh1_5', 'overflowwrap-breakword');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            if(imgs && imgs.length) {
              if(imgs.length > 1) {
                const wrapEl = document.createElement('div');
                wrapEl.classList.add('exhibitor-carousel', 'swiper-wrap', 'rowm-2');
                const carouselEl = document.createElement('div');
                carouselEl.classList.add('swiper-container', 'aspect-4-3');
                const wrapper = document.createElement('div');
                wrapper.classList.add('swiper-wrapper');
                imgs.forEach((src) => {
                  const slide = document.createElement('div');
                  slide.classList.add('swiper-slide');
                  const img = document.createElement('img');
                  img.src = src;
                  img.alt = '';
                  slide.appendChild(img);
                  wrapper.appendChild(slide);
                });
                carouselEl.appendChild(wrapper);
                wrapEl.appendChild(carouselEl);
                const controls = document.createElement('div');
                controls.classList.add('position-relative', 'rowm-0_5', 'flex', 'is-justify-content-center');
                const prevBtn = document.createElement('div');
                prevBtn.classList.add('swiper-button-prev');
                prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 19L8 12L15 5" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                controls.appendChild(prevBtn);
                const nextBtn = document.createElement('div');
                nextBtn.classList.add('swiper-button-next');
                nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5L16 12L9 19" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                controls.appendChild(nextBtn);
                const count = document.createElement('div');
                count.classList.add('swiper-count');
                controls.appendChild(count);
                wrapEl.appendChild(controls);
                drawer.appendChild(wrapEl);
                initImageCarousel(carouselEl);
              } else {
                const singleImg = document.createElement('div');
                singleImg.classList.add('exhibitor-carousel', 'rowm-2', 'aspect-4-3');
                const img = document.createElement('img');
                img.src = imgs[0];
                img.alt = '';
                singleImg.appendChild(img);
                drawer.appendChild(singleImg);
              }
            }

            if(g || o){
              const attr = document.createElement('div');
              attr.classList.add('rowm-2', 'lh1_5');

              if(g){
                const container = document.createElement('div');
                container.classList.add('rowm-1', 'flex');
                const label = document.createElement('p');
                label.classList.add('font-bold', 'pr-0_5');
                label.innerHTML = fabfLabels.genre;
                container.appendChild(label);
                const value = document.createElement('p');
                value.innerHTML = g;
                container.appendChild(value);
                attr.appendChild(container);
              }

              if(o){
                const container = document.createElement('div');
                container.classList.add('rowm-1', 'flex');
                const label = document.createElement('p');
                label.classList.add('font-bold', 'pr-0_5');
                label.innerHTML = fabfLabels.day;
                container.appendChild(label);
                const value = document.createElement('p');
                value.innerHTML = o;
                container.appendChild(value);
                attr.appendChild(container);
              }

              drawer.appendChild(attr);
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }

            const uwFiltered = uw.filter((u) => u['url']);
            const snsItems = [];
            ui.forEach((u) => { if(u['url']) snsItems.push({ type: 'instagram', url: u['url'] }); });
            ux.forEach((u) => { if(u['url']) snsItems.push({ type: 'x', url: u['url'] }); });
            uf.forEach((u) => { if(u['url']) snsItems.push({ type: 'facebook', url: u['url'] }); });

            if(info || uwFiltered.length || snsItems.length) {
              const frame = document.createElement('div');
              frame.classList.add('rowm-2', 'border', 'radius-small', 'pt-2', 'pb-2', 'pr-2', 'pl-2', 'pt-1_5-sp', 'pb-1_5-sp', 'pl-1_5-sp', 'pr-1_5-sp');

              if(t){
                const frameTitle = document.createElement('h5');
                frameTitle.classList.add('rowm-1', 'textsize-article', 'font-bold', 'lh1_5', 'overflowwrap-breakword');
                frameTitle.innerHTML = t;
                frame.appendChild(frameTitle);
              }

              if(info){
                const frameInfo = document.createElement('div');
                frameInfo.classList.add('rowm-1', 'text', 'lh2');
                frameInfo.innerHTML = info;
                frame.appendChild(frameInfo);
              }

              if(uwFiltered.length){
                const ul = document.createElement('ul');
                ul.classList.add('rowm-1', 'lh1_5');
                uwFiltered.forEach((u) => {
                  const el = document.createElement('li');
                  el.classList.add('rowm-0_5', 'overflowwrap-breakword');
                  const _el = document.createElement('a');
                  const label = u['label'];
                  const url = u['url'];
                  _el.setAttribute('href', url);
                  _el.setAttribute('target', '_blank');
                  _el.setAttribute('rel', 'noopener');
                  _el.classList.add('textdecoration-underline', 'hover-textdecoration-none', 'hover-textdecoration-target');
                  if(label) {
                    _el.innerHTML = `${label}`;
                  } else {
                    _el.innerHTML = `${url}`;
                  }
                  el.appendChild(_el);
                  ul.appendChild(el);
                })
                frame.appendChild(ul);
              }

              if(snsItems.length) {
                const snsRow = document.createElement('div');
                snsRow.classList.add('sns-icons', 'rowm-1');

                const svgMap = {
                  instagram: '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="M469.346 369.027c0 55.713-45.44 100.644-100.446 100.644h-226.004c-55.604 0-100.446-45.529-100.446-100.644v-226.448c0-55.713 45.44-100.644 100.446-100.644h226.004c55.604 0 100.446 45.529 100.446 100.644v226.448zm-100.446-369.027h-226.004c-78.922 0-142.896 64.1-142.896 142.579v226.448c0 78.478 63.975 142.579 142.299 142.579h226.601c78.324 0 142.299-64.1 142.299-142.579v-226.448c0-78.478-63.975-142.579-142.299-142.579z"></path><path d="M255.898 346.262c-49.625 0-90.282-40.737-90.282-90.46 0-49.723 40.657-90.46 90.282-90.46s90.282 40.737 90.282 90.46c0 49.723-40.657 90.46-90.282 90.46m0-222.854c-72.943 0-132.134 59.907-132.134 132.394 0 73.087 59.191 132.394 132.134 132.394 72.943 0 132.134-59.308 132.134-132.394 0-72.487-59.191-132.394-132.134-132.394"></path><path d="M391.62 86.865c18.822 0 34.08 15.288 34.08 34.147 0 18.859-15.258 34.147-34.08 34.147s-34.08-15.288-34.08-34.147c0-18.859 15.258-34.147 34.08-34.147"></path></g></svg>',
                  x: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M300.054 219.765L472.441 19.379h-40.85L281.907 193.37 162.356 19.379H24.466l180.786 263.107L24.467 492.62h40.852L223.39 308.88 349.644 492.62h137.89l-187.49-272.856h.01zm-55.953 65.039l-18.317-26.2L80.039 50.132h62.747l117.618 168.244 18.317 26.2 152.89 218.69h-62.748L244.101 284.815v-.01z"></path></svg>',
                  facebook: '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M298.232 511.998v-256.03h75.734l10.036-88.23h-85.77l.13-44.158c0-23.012 2.343-35.341 37.758-35.341h47.346V0H307.72C216.74 0 184.714 42.8 184.714 114.777v52.973H128v88.23h56.714V512H298.23l.002-.002z" fill-rule="evenodd"></path></svg>'
                };

                snsItems.forEach((item) => {
                  const a = document.createElement('a');
                  a.classList.add('sns-icon', 'social-' + item.type, 'js-hov');
                  a.setAttribute('href', item.url);
                  a.setAttribute('target', '_blank');
                  a.setAttribute('rel', 'noopener');
                  a.innerHTML = svgMap[item.type];
                  snsRow.appendChild(a);
                });
                frame.appendChild(snsRow);
              }

              drawer.appendChild(frame);
            }
            drawerHandler();
          }
        }
      })
    })
  }

  // ドロワーclose時
  const triggerReset = document.querySelectorAll('.trigger');
  if(triggerReset.length) {
    triggerReset.forEach((el) => {
      el.addEventListener('click', function(e) {
        if (!document.body.classList.contains('is-drawer-active')) return;
        drawerInit();
      });
    });
  }

  const historyBackTriggers = document.querySelectorAll('.js-history-back');
  if(historyBackTriggers.length){
    historyBackTriggers.forEach((el) => {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        history.back()
      });
    })
  }
}
